const REPLAY_FORCED_COMPONENTS = ['Auth/Register', 'Public/RegistrationForm', 'Public/RegistrationPaymentLink']

export function shouldForceReplayCapture(component: string): boolean {
    return REPLAY_FORCED_COMPONENTS.includes(component)
}
